import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import IPAddress from 'flarum/common/components/IPAddress';
import LabelValue from 'flarum/common/components/LabelValue';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import extractText from 'flarum/common/utils/extractText';
/**
 * Lists the OAuth clients the current user has granted access to, as their
 * browser sessions are listed, with a button to revoke each grant.
 */
export default class ConnectedApplications extends Component {
  consents = null;
  revoking = {};
  revokingAll = false;
  oninit(vnode) {
    super.oninit(vnode);
    app.store.find('oauth-consents').then(consents => this.consents = consents).catch(() => this.consents = []).finally(() => m.redraw());
  }
  view() {
    if (this.consents === null) return m(LoadingIndicator, {
      display: "block"
    });
    return [m("div", {
      className: "AccessTokensList ConnectedApplications"
    }, this.consents.length ? this.consents.map(consent => this.item(consent)) : m("div", {
      className: "AccessTokensList--empty"
    }, app.translator.trans('flarum-oauth-provider.forum.connected_apps.empty'))), this.consents.length > 1 && m("div", {
      className: "UserSecurityPage-controls"
    }, m(Button, {
      className: "Button ConnectedApplications-revokeAll",
      loading: this.revokingAll,
      onclick: () => this.revokeAll()
    }, app.translator.trans('flarum-oauth-provider.forum.connected_apps.revoke_all_button')))];
  }
  item(consent) {
    const host = consent.clientSourceHost();
    const logo = consent.clientLogoUrl();
    const lastUsed = consent.lastUsedAt();
    return m("div", {
      className: "AccessTokensList-item ConnectedApplications-item",
      key: consent.id()
    }, m("div", {
      className: "AccessTokensList-item-icon"
    }, logo ? m("img", {
      className: "ConnectedApplications-logo",
      src: logo,
      alt: ""
    }) : m(Icon, {
      name: "fas fa-plug"
    })), m("div", {
      className: "AccessTokensList-item-info"
    }, m("div", {
      className: "AccessTokensList-item-title"
    }, m("span", {
      className: "AccessTokensList-item-title-main"
    }, consent.clientName()), host ? [' — ', m("span", {
      className: "AccessTokensList-item-title-sub"
    }, app.translator.trans('flarum-oauth-provider.forum.connected_apps.from_host', {
      host
    }))] : null), m("div", {
      className: "AccessTokensList-item-createdAt"
    }, m(LabelValue, {
      label: app.translator.trans('flarum-oauth-provider.forum.connected_apps.connected'),
      value: humanTime(consent.createdAt())
    })), m("div", {
      className: "AccessTokensList-item-lastActivityAt"
    }, m(LabelValue, {
      label: app.translator.trans('flarum-oauth-provider.forum.connected_apps.last_used'),
      value: lastUsed ? m('[', null, humanTime(lastUsed), consent.lastIpAddress() && m("span", null, ' ', "\u2014 ", m(IPAddress, {
        ip: consent.lastIpAddress()
      }))) : app.translator.trans('flarum-oauth-provider.forum.connected_apps.never_used')
    })), m("div", {
      className: "ConnectedApplications-scopes"
    }, (consent.scopes() || []).map(scope => m("code", null, scope)))), m("div", {
      className: "AccessTokensList-item-actions"
    }, m(Button, {
      className: "Button Button--danger",
      loading: !!this.revoking[consent.id()],
      onclick: () => this.revoke(consent)
    }, app.translator.trans('flarum-oauth-provider.forum.connected_apps.revoke_button'))));
  }
  async revoke(consent) {
    const message = extractText(app.translator.trans('flarum-oauth-provider.forum.connected_apps.revoke_confirm', {
      client: consent.clientName()
    }));
    if (!confirm(message)) return;
    this.revoking[consent.id()] = true;
    m.redraw();
    try {
      await consent.delete();
      this.consents = (this.consents || []).filter(other => other !== consent);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('flarum-oauth-provider.forum.connected_apps.revoked', {
        client: consent.clientName()
      }));
    } finally {
      this.revoking[consent.id()] = false;
      m.redraw();
    }
  }
  async revokeAll() {
    if (!confirm(extractText(app.translator.trans('flarum-oauth-provider.forum.connected_apps.revoke_all_confirm')))) return;
    this.revokingAll = true;
    m.redraw();
    try {
      await app.request({
        method: 'DELETE',
        url: app.forum.attribute('apiUrl') + '/oauth-consents'
      });
      (this.consents || []).forEach(consent => app.store.remove(consent));
      this.consents = [];
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('flarum-oauth-provider.forum.connected_apps.revoked_all'));
    } finally {
      this.revokingAll = false;
      m.redraw();
    }
  }
}
flarum.reg.add('flarum-oauth-provider', 'forum/components/ConnectedApplications', ConnectedApplications);